/** @jsx jsx */
import React from "react"
import { graphql } from "gatsby"
import { jsx, Container, Grid, Heading } from "theme-ui"
import ThemeContainer from "../../shared/ThemeContainer"
import GenerateGridItems from "./generateGridItems"
// import * as gridSectionStyles from "./gridsection.module.css";
import "./gridsection.css"

export const query = graphql`
  fragment ContentfulGridSectionFragment on ContentfulGridSection {
    theme {
      backgroundColor
      textColor
      backgroundImageClass
      backgroundImage {
        gatsbyImageData
        id
        title
      }
    }
    heading
    maxColumns
    className
    gridItems {
      __typename
      ... on ContentfulGridItem {
        ...GridItemFragment
        id
      }
      ... on ContentfulBulletListItem {
        ...BulletListItemFragment
        id
      }
      ... on ContentfulCardItem {
        ...CardItemFragment
        id
      }
      ... on ContentfulHubspotForm {
        ...HubspotFormItemFragment
        id
      }
      ... on ContentfulRichTextSection {
        ...ContentfulRichTextSectionFragment
        id
      }
    }
  }

  fragment HubspotFormItemFragment on ContentfulHubspotForm {
    id
    slug
    region
    portalId
    formId
    name
  }
`
const GridSection = ({ sectionContent }) => {
  const { theme, maxColumns, gridItems, heading, className } = sectionContent
  return (
    <ThemeContainer
      {...theme}
      py={["50px", "100px"]}
      px={["0", "40px"]}
      className={`${className === "grid-company-page" ? "grid-theme-container" : className}`}
    >
      <Container className="grid-container">
        {heading && (
          <Heading variant="bold" className="grid-header" sx={{ color: theme?.textColor }}>
            {heading}
          </Heading>
        )}
        <Grid
          columns={[1, 2, 2, maxColumns || 4]}
          className={`${className}` || "grid"}
          sx={{ columnGap: "90px", gridGap: ["16px","35px"] }}
        >
          {gridItems.map((gridItem) => (
            <GenerateGridItems
              key={gridItem.id}
              gridItem={gridItem}
              maxColumns={maxColumns}
              textColor={theme?.textColor}
              classname={className}
            />
          ))}
        </Grid>
      </Container>
    </ThemeContainer>
  )
}

export default GridSection
